import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactJSON from 'shared/design-system/components/TrueImpactJSON';
import { ShouldExpandNodeInitially } from 'react-json-tree';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

interface RenderLocationAnswerProps {
  shouldExpend?: ShouldExpandNodeInitially;
  parseObject: {
    address: string;
    type: 'all';
    percentage: number;
  }[];
}

const StyledDiv = styled.div`
  margin-top: ${SPACERS.small};
  .location {
    margin-bottom: ${SPACERS.small};
  }
`;

const RenderLocationAnswer: React.FC<RenderLocationAnswerProps> = ({
  parseObject,
  shouldExpend,
}) => {
  try {
    return (
      <StyledDiv>
        {parseObject.map(x => (
          <TrueImpactText
            variant="body-small"
            key={x.address}
            className="location"
          >
            <strong>Location:</strong> {x.address}
            <br />
            <strong>Percentage:</strong> {x.percentage}%
          </TrueImpactText>
        ))}
      </StyledDiv>
    );
  } catch (e) {
    return (
      <TrueImpactJSON parseObject={parseObject} shouldExpend={shouldExpend} />
    );
  }
};

export default RenderLocationAnswer;
